import React from 'react';
import { color, boxShadow } from '../constants';
import styled from 'styled-components';
import { RaosWrapper } from 'raos';
import { Container, Row, Col } from 'react-bootstrap';
import detailed from '../imnages/detailed.png';

const DetailCont = styled.div`
  margin-top: 2rem;
  padding: 1rem;
  box-shadow: ${boxShadow.outset};
  border-radius: .5rem;
`
const Title = styled.h2`
  display: inline-block;
  text-transform: uppercase;
  border-bottom: 5px solid ${color.prim};
  padding: .5rem 0;
`
const SubTitle = styled.h3`
  text-transform: uppercase;
  padding: .5rem 0;
  margin: 0;
`
const InfoCont = styled.div`
  padding: 1rem;
  border-radius: .5rem;
  box-shadow: ${boxShadow.inset};
`
const CodeImg = styled.img`
  width: 100%;
  object-fit: cover;
  object-position: center;
`
const Info = styled.p`
  text-align: justify;
  margin: 0;
`
export default ()=> {

  return(
    <Container>
      <RaosWrapper className="animated bounce">
        <DetailCont>
          <Title>detailed</Title>
          <InfoCont>
            <Row>
              <Col className="d-flex align-items-center" xs={12} sm={6}>
                <CodeImg src={detailed} alt="detailed code" />
              </Col>
              <Col xs={12} sm={6}>
                <SubTitle>1-import</SubTitle>
                <Info>Import RaosWrapper.</Info>
                <SubTitle>2-Use it</SubTitle>
                <Info>Use it like any parent component.</Info>
                <SubTitle>3-Percent</SubTitle>
                <Info>Assigns an integer between 0 and 100, equivalent to the percentage of intersection, when the percentage of its component is intercepted, the animation will fire.</Info>
                <SubTitle>4-Class</SubTitle>
                <Info>Add the class that contains your animation or whatever you want to happen when your component is intercepted. You can even add your own styles to RaosWrapper if necessary.</Info>
                <SubTitle>5-Wrap it</SubTitle>
                <Info>Wrap your component with RaosWrapper.</Info>
              </Col>
            </Row>
          </InfoCont>
        </DetailCont>
      </RaosWrapper>
    </Container>
  )
}
